import { render, staticRenderFns } from "./admin_audit_log.vue?vue&type=template&id=63199a10&scoped=true&"
import script from "./admin_audit_log.vue?vue&type=script&lang=ts&"
export * from "./admin_audit_log.vue?vue&type=script&lang=ts&"
import style0 from "./admin_audit_log.vue?vue&type=style&index=0&id=63199a10&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63199a10",
  null
  
)

export default component.exports